import { render, staticRenderFns } from "./promList.vue?vue&type=template&id=c18b2254&scoped=true&"
import script from "./promList.vue?vue&type=script&lang=js&"
export * from "./promList.vue?vue&type=script&lang=js&"
import style0 from "./promList.vue?vue&type=style&index=0&id=c18b2254&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c18b2254",
  null
  
)

export default component.exports